<template>
  <div>
    <div  v-if="pkb || pkb != null" class="md-layout noprint">
      <md-toolbar class="color md-dense" style="width:100%;">
        <div style="width:50%">
          <h3 class="md-title" style="flex:1; margin-left:10px;">
            <p v-if="pkb.pkb_status==0" style="text-align: left; font-weight:bold;">REGISTERED</p>
            <p  v-if="pkb.pkb_status==1" style="text-align: left; font-weight:bold;">WAITING SERVICE</p>
            <p  v-if="pkb.pkb_status==2" style="text-align: left; font-weight:bold;">SERVICE IN-PROGRESS</p>
            <p  v-if="pkb.pkb_status==3" style="text-align: left; font-weight:bold;">WAITING PART</p>
            <p  v-if="pkb.pkb_status==4" style="text-align: left; font-weight:bold;">COMPLETED</p>
            <p  v-if="pkb.pkb_status==5" style="text-align: left; font-weight:bold;">WAITING CANCEL CONFIRMATION</p>
            <p  v-if="pkb.pkb_status==6" style="text-align: left; font-weight:bold;">CANCELED</p>
          </h3>
        </div>
        <div style="width:50%">
          <div class="md-toolbar-section-end">
            <md-menu md-direction="bottom-start">
              <md-button v-if="pkb.pkb_status!=4 && pkb.pkb_status!=6 " class="nonprint; color md-dense" md-menu-trigger>Change Status</md-button>
              <md-menu-content>
                <md-menu-item v-if="pkb.pkb_status==0 && role.requester" class="noprint" @click="updateStatusConfirmation('Request service')">Request Service</md-menu-item>
                <md-menu-item v-if="pkb.pkb_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation('Start service')">Start service</md-menu-item>
                <md-menu-item v-if="pkb.pkb_status==2 && role.approver" class="noprint" @click="updateStatusConfirmation('Service completed')">Service completed</md-menu-item>
                <md-menu-item v-if="pkb.pkb_status==2 && role.requester" class="noprint" @click="updateStatusConfirmation('Waiting Part')">Waiting Part</md-menu-item>
                <md-menu-item v-if="pkb.pkb_status==3 && role.approver" class="noprint" @click="updateStatusConfirmation('Resume service')">Resume service</md-menu-item>
                <md-menu-item v-if="pkb.pkb_status!=0 && pkb.pkb_status!=5  && role.requester" class="noprint" @click="updateStatusConfirmation('Request Cancel')">Request Cancel</md-menu-item>
                <md-menu-item v-if="pkb.pkb_status==5 && role.approver" class="noprint" @click="updateStatusConfirmation('Approve Cancel')">Approve Cancel</md-menu-item>
                <md-menu-item v-if="pkb.pkb_status==5 && role.approver" class="noprint" @click="updateStatusConfirmation('Not Approve Cancel')">Not Approve Cancel</md-menu-item>
              </md-menu-content>
            </md-menu>
            <md-button  class="noprint md-dense md-icon-button color" @click="printPage()" ><md-icon>print</md-icon></md-button>
            <!-- <md-menu md-direction="bottom-start" style="margin-right:20px;">
              <md-button class="nonprint; md-info md-dense md-icon-button" md-menu-trigger><md-icon>more_vert</md-icon></md-button>
              <md-menu-content>
                <md-menu-item v-if="!pkb.pkb_nota_part && pkb.pkb_status==4 && pkb.pkb_part.length!=0" @click="createNotaPart(pkb.id)">Create Nota Part</md-menu-item>
                <md-menu-item v-if="!pkb.pkb_nota_service && pkb.pkb_status==4" @click="createNotaJasa(pkb.id,pkb.pkb_no)">Create Nota Jasa</md-menu-item>
                <md-menu-item v-if="!pkb.pkb_faktur && pkb.pkb_nota_service && (pkb.pkb_part.length==0|| pkb.pkb_nota_part)" @click="createFaktur(pkb.id)">Create Faktur</md-menu-item>
                <md-menu-item v-if="pkb.pkb_nota_part!=null" @click="showNotaPart(pkb.pkb_nota_part.id)">View Nota Part</md-menu-item>
                <md-menu-item v-if="pkb.pkb_nota_service!=null" @click="showNotaJasa(pkb.pkb_nota_service.id)">View Nota Jasa Bkl</md-menu-item>
                <md-menu-item v-if="pkb.pkb_faktur!=null" @click="showFaktur(pkb.pkb_faktur.id)">View Faktur</md-menu-item> 
                <md-menu-item v-if="pkb.pkb_status != 4 && role.update" @click="editPkb(pkb.id)">Edit</md-menu-item>
                <md-menu-item v-if="pkb.pkb_status == 0  && role.delete" @click="deleteConfirmation(pkb.id)">Delete</md-menu-item>
                <md-menu-item @click="backtoList">Back to PKB list</md-menu-item>
              </md-menu-content>
            </md-menu> -->
            <md-button class="md-icon-button md-dense color" @click="closeDetail()"><md-icon>close</md-icon></md-button>
          </div>
        </div>
      </md-toolbar>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-card>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head><b>PKB No</b></md-table-head>
                  <md-table-head><b>Tanggal PKB</b></md-table-head>
                  <md-table-head><b>Work Orde Type</b></md-table-head>
                  <md-table-head><b>Repeat Order</b></md-table-head>
                  <md-table-head><b>Service Advisor</b></md-table-head>
                  <md-table-head><b>Teknisi</b></md-table-head>
                  <md-table-head><b>Rencana Pembayaran</b></md-table-head>
                </md-table-row>
                <md-table-row> 
                  <md-table-cell>{{pkb.pkb_no}}</md-table-cell>
                  <md-table-cell>{{pkb.pkb_datetime}}</md-table-cell>
                  <md-table-cell>{{pkb.pkb_work_order_type}}</md-table-cell>
                  <md-table-cell>{{pkb.pkb_repeat_order}}</md-table-cell>
                  <md-table-cell>{{pkb.pkb_service_estimate.sa_name.name}}</md-table-cell>
                  <md-table-cell>{{pkb.pkb_teknisi_name.name}}</md-table-cell>
                  <md-table-cell>{{pkb.pkb_payment_plan}}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>

        <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-primary">
              <div class="card-text">
                <h4 class="title">Client</h4>
              </div>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Service Estimate No</md-table-cell>
                  <md-table-cell>{{ pkb.pkb_service_estimate.service_estimate_no}}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Clien No</md-table-cell>
                  <md-table-cell>{{ pkb.pkb_service_estimate.client.client_no}}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Name</md-table-cell>
                  <md-table-cell>{{ pkb.pkb_service_estimate.client.client_name}}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Phone</md-table-cell>
                  <md-table-cell>{{ pkb.pkb_service_estimate.client.client_phone}}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Email</md-table-cell>
                  <md-table-cell>{{ pkb.pkb_service_estimate.client.client_email}}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Address</md-table-cell>
                  <md-table-cell>{{ pkb.pkb_service_estimate.client.client_address}}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100" >
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-primary">
              <div class="card-text">
                <h4 class="title">Vehicle</h4>
              </div>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Plat No</md-table-cell>
                  <md-table-cell>{{pkb.vehicle_plat_no}}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Merk/Type</md-table-cell>
                  <md-table-cell>{{pkb.vehicle_vehicle_model}}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Engine No</md-table-cell>
                  <md-table-cell>{{pkb.vehicle_engine_no}}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Chassis No</md-table-cell>
                  <md-table-cell>{{ pkb.vehicle_chassis_no}}</md-table-cell>
                </md-table-row>
                <!-- <md-table-row>
                  <md-table-cell style="font-weight:bold;">Kilometer</md-table-cell>
                  <md-table-cell>{{ pkb.pkb_service_estimate.service_estimate_vehicle_km}}</md-table-cell>
                </md-table-row> -->
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">KM Masuk</md-table-cell>
                  <md-table-cell>{{pkb.pkb_service_estimate.service_estimate_vehicle_km}}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Bahan Bakar</md-table-cell>
                  <md-table-cell>{{pkb.vehicle_fuel_type}}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>

        <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100" style="margin-top:10px;">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-primary">
              <div class="card-text">
                <h4 class="title">Spare Part</h4>
              </div>
            </md-card-header>
            <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head ><b>Spare Part No</b></md-table-head>
                <md-table-head><b>Spare Part Name</b></md-table-head>
                <md-table-head><b>Qty</b></md-table-head>
              </md-table-row>
              <md-table-row v-if="!type_part['1']">
                <md-table-cell colspan="5" style="text-align:center; color:#aaaa; text-decoration:underline;"> No spare part are selected</md-table-cell>
              </md-table-row>
              <md-table-row v-else v-for="(item, index)  in type_part['1']" :key="index">
                <md-table-cell >{{ item.spare_part_master_code }}</md-table-cell>
                <md-table-cell >{{item.spare_part_master_name}}</md-table-cell>
                <md-table-cell>{{item.pkb_spare_part_qty}}</md-table-cell>
              </md-table-row>
            </md-table>
            </md-card-content>
          </md-card>
        </div>

        <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100" style="margin-top:10px;">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-primary">
              <div class="card-text">
                <h4 class="title">Material</h4>
              </div>
            </md-card-header>
            <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head ><b>Material No</b></md-table-head>
                <md-table-head><b>Material Name</b></md-table-head>
                <md-table-head><b>Qty</b></md-table-head>
              </md-table-row>
              <md-table-row v-if="!type_part['2']">
                <md-table-cell colspan="5" style="text-align:center; color:#aaaa; text-decoration:underline;"> No material are selected</md-table-cell>
              </md-table-row>
              <md-table-row v-else v-for="(item, index)  in type_part['2']" :key="index">
                <md-table-cell >{{ item.spare_part_master_code }}</md-table-cell>
                <md-table-cell >{{item.spare_part_master_name}}</md-table-cell>
                <md-table-cell>{{item.pkb_spare_part_qty}}</md-table-cell>
              </md-table-row>
            </md-table>
            </md-card-content>
          </md-card>
        </div>

        <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-100 md-small-size-100" style="margin-top:10px;">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-primary">
              <div class="card-text">
                <h4 class="title">Service</h4>
              </div>
            </md-card-header>
            <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head ><b>Code</b></md-table-head>
                <md-table-head><b>Service Name</b></md-table-head>
                <md-table-head><b>Lts</b></md-table-head>
                <md-table-head><b>Discount</b></md-table-head>
                <md-table-head><b>Price</b></md-table-head>
              </md-table-row>
              <md-table-row v-if="!pkb.pkb_service">
                <md-table-cell colspan="5" style="text-align:center; color:#aaaa; text-decoration:underline;"> No Service are selected</md-table-cell>
              </md-table-row>
              <md-table-row v-else v-for="(item, index)  in pkb.pkb_service" :key="index">
                <md-table-cell >{{ item.service_master_code }}</md-table-cell>
                <md-table-cell >{{item.service_master_name}}</md-table-cell>
                <md-table-cell>{{item.pkb_service_lts}}</md-table-cell>
                <md-table-cell>{{item.pkb_service_discount}}</md-table-cell>
                <md-table-cell>{{item.pkb_service_price}}</md-table-cell>
              </md-table-row>
            </md-table>
            </md-card-content>
          </md-card>
        </div>

        <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-100 md-small-size-100" style="margin-top:10px;">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-primary">
              <div class="card-text">
                <h4 class="title">Kelengkapan</h4>
              </div>
            </md-card-header>
            <md-card-content>
              <md-table style="margin-top:20px; margin-bottom:20px;">
              <tr>
                
                <td class="checkboxes" >
                  <label style="margin-right:70px; "><input style="width: 30px; height: 30px; " type="checkbox" v-model="pkb.pkb_spion"  disabled> <span>Spion</span></label>
                </td>
                <td class="checkboxes">
                  <label style="margin-right:70px;"><input style="width: 30px; height: 30px;" type="checkbox" v-model="pkb.pkb_battery_1" disabled> <span>Battery 1</span></label>
                </td>
                <td class="checkboxes">
                  <label style="margin-right:70px;"><input style="width: 30px; height: 30px;" type="checkbox" v-model="pkb.pkb_battery_2" disabled> <span>Battery 2</span></label>
                </td>
                <td class="checkboxes">
                  <label style="margin-right:70px;"><input style="width: 30px; height: 30px;" type="checkbox" v-model="pkb.pkb_rak_depan" disabled> <span>Rak Depan</span></label>
                </td>
                <td class="checkboxes">
                  <label style="margin-right:70px;"><input style="width: 30px; height: 30px;" type="checkbox" v-model="pkb.pkb_rak_belakang" disabled> <span>Rak Belakang</span></label>
                </td>
              </tr>
        
              </md-table>
            </md-card-content>
          </md-card>
        </div>

        <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100" style="margin-top:10px;">
          <md-card >
            <md-card-header class="md-card-header-text md-card-header-primary">
              <div class="card-text">
                <h4 class="title">Keluhan</h4>
              </div>
              <!-- <div class="md-subhead">With hover and ripple effects</div> -->
            </md-card-header>

            <md-card-content>
              <md-table style="margin-top:20px; margin-bottom:20px;">
                <!-- <md-table-row v-for="(item, index)  in pkb.pkb_service_estimate.keluhan" :key="index">
                  <md-table-cell> {{ index +1}}</md-table-cell>
                  <md-table-cell>{{item.keluhan}}</md-table-cell>
                </md-table-row> -->
                <tr v-if="pkb.pkb_service_estimate.keluhan.length==0">
                  <td style="text-align:center; color:#aaaa; text-decoration:underline"> No Data Available </td>
                </tr >
                <tr v-else v-for="(item, index)  in pkb.pkb_service_estimate.keluhan" :key="index">
                  <td> {{ index +1}}</td>
                  <td>{{item.keluhan}}</td>
                </tr>
              </md-table>
            </md-card-content>
          </md-card>
        </div>

        <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100" style="margin-top:10px;">
          <md-card >
              <md-card-header class="md-card-header-text md-card-header-primary">
              <div class="card-text">
                <h4 class="title">Analisa</h4>
              </div>
              <!-- <div class="md-subhead">With hover and ripple effects</div> -->
            </md-card-header>

            <md-card-content>
              <md-table style="margin-top:20px;  margin-bottom:20px;">
                <!-- <md-table-row v-for="(item, index)  in pkb.pkb_service_estimate.keluhan" :key="index">
                  <md-table-cell> {{ index +1}}</md-table-cell>
                  <md-table-cell>{{item.keluhan}}</md-table-cell>
                </md-table-row> -->
                <tr v-if="pkb.pkb_service_estimate.keluhan.length==0">
                  <td style="text-align:center; color:#aaaa; text-decoration:underline"> No Data Available </td>
                </tr >
                <tr v-else v-for="(item, index)  in pkb.pkb_service_estimate.keluhan" :key="index">
                  <td v-if="item.analisa!=null"> {{ index +1}}</td>
                  <td v-if="item.analisa!=null">{{item.analisa}}</td>
                </tr>
              </md-table>
            </md-card-content>
          </md-card>
        </div>

        <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-100 md-small-size-100">
          <md-card >
              <md-card-header class="md-card-header-text md-card-header-primary">
              <div class="card-text">
                <h4 class="title">Perintah Kerja</h4>
              </div>
              <!-- <div class="md-subhead">With hover and ripple effects</div> -->
            </md-card-header>

            <md-card-content>
              <md-table style="margin-top:20px; margin-bottom:20px;">
                <!-- <md-table-row v-for="(item, index)  in pkb.pkb_service_estimate.keluhan" :key="index">
                  <md-table-cell> {{ index +1}}</md-table-cell>
                  <md-table-cell>{{item.keluhan}}</md-table-cell>
                </md-table-row> -->
                <tr v-if="pkb.pkb_perintah_kerja==null">
                  <td style="text-align:center; color:#aaaa; text-decoration:underline"> No Data Available </td>
                </tr >
                <tr v-else>
                  <td><pre>{{pkb.pkb_perintah_kerja}}</pre></td>
                </tr>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
    </div>
              
         
    <div v-if="pkb" class="md-layout print">
      <div class="md-layout-item md-size-100">
        <md-content> 
          <table class="noprint" style="width: 100%; table-layout: fixed; text-transform: capitalize ;">
            <colgroup>
              <col style="width: 7mm">
              <col style="width: 18mm">
              <col style="width: 20mm">
              <col style="width: 120mm">
              <col style="width: 15mm">
            </colgroup>
            <tr>
              <td >Status :</td>
              <td>
                <p v-if="pkb.pkb_status==0" style="text-align: left;">Registered</p>
                <p  v-if="pkb.pkb_status==1" style="text-align: left;">Waiting service</p>
                <p  v-if="pkb.pkb_status==2" style="text-align: left;">Service in-progress</p>
                <p  v-if="pkb.pkb_status==3" style="text-align: left;">Waiting Part</p>
                <p  v-if="pkb.pkb_status==4" style="text-align: left;">Completed</p>
                <p  v-if="pkb.pkb_status==5" style="text-align: left;">Waiting cancel confirmation</p>
                <p  v-if="pkb.pkb_status==6" style="text-align: left;">Canceled</p>
              </td>
              <td >
                <md-menu md-direction="bottom-start">
                  <md-button v-if="pkb.pkb_status!=4 && pkb.pkb_status!=6 " class="nonprint; md-info" md-menu-trigger>Change Status</md-button>
                  <md-menu-content>
                    <md-menu-item v-if="pkb.pkb_status==0 && role.requester" class="noprint" @click="updateStatusConfirmation('Request service')">Request Service</md-menu-item>
                    <md-menu-item v-if="pkb.pkb_status==1 && role.approver" class="noprint" @click="updateStatusConfirmation('Start service')">Start service</md-menu-item>
                    <md-menu-item v-if="pkb.pkb_status==2 && role.approver" class="noprint" @click="updateStatusConfirmation('Service completed')">Service completed</md-menu-item>
                    <md-menu-item v-if="pkb.pkb_status==2 && role.requester" class="noprint" @click="updateStatusConfirmation('Waiting Part')">Waiting Part</md-menu-item>
                    <md-menu-item v-if="pkb.pkb_status==3 && role.approver" class="noprint" @click="updateStatusConfirmation('Resume service')">Resume service</md-menu-item>
                    <md-menu-item v-if="pkb.pkb_status!=0 && pkb.pkb_status!=5  && role.requester" class="noprint" @click="updateStatusConfirmation('Request Cancel')">Request Cancel</md-menu-item>
                    <md-menu-item v-if="pkb.pkb_status==5 && role.approver" class="noprint" @click="updateStatusConfirmation('Approve Cancel')">Approve Cancel</md-menu-item>
                    <md-menu-item v-if="pkb.pkb_status==5 && role.approver" class="noprint" @click="updateStatusConfirmation('Not Approve Cancel')">Not Approve Cancel</md-menu-item>
                  </md-menu-content>
                </md-menu>
              </td>
                  
              <td><md-button style="float: right; " class="noprint" @click="printPage()" ><md-icon>print</md-icon></md-button></td>
              <td >
                <md-menu md-direction="bottom-start">
                  <md-button class="nonprint; md-info" md-menu-trigger>Option</md-button>
                  <md-menu-content>
                    <md-menu-item v-if="!pkb.pkb_nota_part && pkb.pkb_status==4 && pkb.pkb_part.length!=0" @click="createNotaPart(pkb.id)">Create Nota Part</md-menu-item>
                    <md-menu-item v-if="!pkb.pkb_nota_service && pkb.pkb_status==4" @click="createNotaJasa(pkb.id,pkb.pkb_no)">Create Nota Jasa</md-menu-item>
                    <md-menu-item v-if="!pkb.pkb_faktur && pkb.pkb_nota_service && (pkb.pkb_part.length==0|| pkb.pkb_nota_part)" @click="createFaktur(pkb.id)">Create Faktur</md-menu-item>
                    <md-menu-item v-if="pkb.pkb_nota_part!=null" @click="showNotaPart(pkb.pkb_nota_part.id)">View Nota Part</md-menu-item>
                    <md-menu-item v-if="pkb.pkb_nota_service!=null" @click="showNotaJasa(pkb.pkb_nota_service.id)">View Nota Jasa Bkl</md-menu-item>
                    <md-menu-item v-if="pkb.pkb_faktur!=null" @click="showFaktur(pkb.pkb_faktur.id)">View Faktur</md-menu-item> 
                    <md-menu-item v-if="pkb.pkb_status == 0 && role.update" @click="editPkb(pkb.id)">Edit</md-menu-item>
                    <md-menu-item v-if="pkb.pkb_status == 0  && role.delete" @click="deleteConfirmation(pkb.id)">Delete</md-menu-item>
                    <!-- <md-menu-item @click="backtoList">Back to PKB list</md-menu-item> -->
                  </md-menu-content>
                </md-menu>
              </td>
            </tr>
          </table>
          
          <table class="print" style="width:100%; table-layout: fixed; border: 1px solid black;" >
            <tr>
              <td style="width:50mm; border: 1px solid black;"  rowspan="4"><img src="@/assets/images/logocharged.png" style="width:100%; max-width:150px;"></td>
              <td style="padding-left:10mm; font-size: 5.5mm;  font-weight: 900; text-decoration: underline;">BENGKEL AUTO NEXT</td>
            </tr>
            <tr>
              <td style="padding-left:10mm; font-size: 5mm; font-weight: 900;">BEKASI</td>
            </tr>
            <tr>
              <td style="padding-left:10mm; font-size: 5mm; font-weight: 900;">Jl. Kranggan Raya No. 26 Jatisampurna - Kota Bekasi - Jawa Barat</td>
            </tr>
            <tr>
              <td style="padding-left:10mm; font-size: 5mm; font-weight: 900;">Phone : 081280004426</td>
            </tr>
          </table>
          
          <table> 
            <tr>
              <td><span style="font-weight: bold;">Tanggal PKB : </span>{{pkb.pkb_datetime}}</td>
              <td style="text-decoration: underline; text-align:center; font-weight: bold;">PERINTAH KERJA BENGKEL</td>
              <td style="text-align: right;"><span style="font-weight: bold;">No PKB : </span>{{pkb.pkb_no}}</td>
            </tr>
          </table>
          
          <table  style="width:100%; border-collapse: collapse; border:1px solid black;">
            <colgroup>
              <col style="width: 40mm">
              <col style="width: 35mm">
              <col style="width: 105mm">
            </colgroup>
            <tr>
              <td style="text-align: center;">
                <img src="@/pages/Dashboard/Workshop/PKB/Component/car_inspection.jpg" style="width:100%;  max-width:150px; ">
              </td>
              <td>
                <table style="border-collapse: collapse; ">
                  
                  <tr>
                    <td class="checkboxes" >
                      <label><input type="checkbox" v-model="pkb.pkb_spion"  disabled> <span>Spion</span></label>
                    </td>
                    <td class="checkboxes">
                      <label><input type="checkbox" v-model="pkb.pkb_battery_1" disabled> <span>Battery 1</span></label>
                    </td>
                  </tr>
                  <tr>
                    <td class="checkboxes">
                      <label><input type="checkbox" v-model="pkb.pkb_battery_2" disabled> <span>Battery 2</span></label>
                    </td>
                    <td class="checkboxes">
                      <label><input type="checkbox" v-model="pkb.pkb_rak_depan" disabled> <span>Rak Depan</span></label>
                    </td>
                  </tr>
                  <tr>
                    <td class="checkboxes">
                      <label><input type="checkbox" v-model="pkb.pkb_rak_belakang" disabled> <span>Rak Belakang</span></label>
                    </td>
                  </tr>
                 
                </table>
              </td>
              <td>
                <table class="info" style="border-collapse: collapse; margin:none !important;">
                  <colgroup>
                    <col style="width: 30mm">
                    <col style="width: 40mm">
                    <col style="width: 20mm">
                    <col style="width: 15mm">
                  </colgroup>
                  <tr>
                    <td style="font-weight:bold">No. Polisi</td>
                    <td>: {{pkb.vehicle_plat_no}}</td>
                    <td style="font-weight:bold">Tahun</td>
                    <td>: {{pkb.vehicle_production_year}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">No. Rangka</td>
                    <td>: {{pkb.vehicle_chassis_no}}</td>
                    <td style="font-weight:bold">Warna</td>
                    <td>: {{pkb.vehicle_colour}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">No. Mesin</td>
                    <td>: {{pkb.vehicle_engine_no}}</td>
                    <td style="font-weight:bold">KM. Masuk</td>
                    <td>: {{pkb.pkb_service_estimate.service_estimate_vehicle_km}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">No. Buku Service</td>
                    <td>: </td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Repeat Order</td>
                    <td>: {{pkb.pkb_repeat_order}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Merek / TYPE</td>
                    <td>: {{pkb.vehicle_vehicle_model}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Bahan Bakar</td>
                    <td>: {{pkb.vehicle_fuel_type}}</td>
                    <td colspan="2"><img src="@/pages/Dashboard/Workshop/PKB/Component/indikator_bahan_bakar.png" style="width:100%;  max-width:150px;"></td>      
                  </tr>
                  <!-- <tr>
                    <td colspan="2"><img src="@/pages/Dashboard/Workshop/PKB/Component/indikator_bahan_bakar.png" style="width:100%;  max-width:150px;"></td>              
                  </tr> -->
                </table>
              </td>
            </tr>
          </table>

            <table class="table-inside-td" style="width:100%; border: 1px solid black; margin-top: 5px; table-layout: fixed;" >
              <colgroup>
                <!-- <col style="width: 8mm">
                <col style="width: 1mm">
                <col style="width: 1mm"> -->
                <col style="width: 14mm">
                <col style="width: 2mm">
                <col style="width: 85mm">
                <col style="width: 32mm">
                <col style="width: 2mm">
                <col style="width: 45mm">
              </colgroup>
              <tr>
                <!-- <td class="bold-title">Data Customer</td>
                <td></td>
                <td></td> -->
                <td class="bold-title">NAMA</td>
                <td>:</td>
                <td >{{pkb.pkb_service_estimate.client.client_name}}</td>
                <td class="bold-title">NO.TELP RMH/OFFICE</td>
                <td>:</td>
                <td ></td>
              </tr>
              <tr>
                <!-- <td class="bold-title"></td>
                <td></td>
                <td></td> -->
                <td class="bold-title">ALAMAT</td>
                <td>:</td>
                <td>{{pkb.pkb_service_estimate.client.client_address}}</td>
                <td class="bold-title">NO. HANDPHONE</td>
                <td>:</td>
                <td>{{pkb.pkb_service_estimate.client.client_phone}}</td>
              </tr>
            </table>
            
            <table class="table-inside-td" style="width:100%;  border: 1px solid black; margin-top: 5px; table-layout: fixed;" >
              <colgroup>
                <col style="width: 90mm">
                <col style="width: 90mm">
              </colgroup>
              <tr>
                <!-- <td><b>Keluhan :</b><br>
                  <table  style="border-collapse: width:100%; collapse; margin-top:10px; margin-bottom:10px;">
                    <colgroup>
                      <col style="width: 2mm">
                      <col style="width: 78mm">
                    </colgroup>
                    <tr  v-for="(item, index)  in pkb.pkb_service_estimate.keluhan"
                      :key="index">
                      <td >{{ index+1 }}.</td>
                      <td >{{ item.keluhan }}</td>
                    </tr>
                  </table>
                </td> -->
                <td>
                  <table v-if="type_part" class="table-kotak" style="border-collapse: collapse; margin-top:5px; margin-bottom:5px;">
                    <thead>
                      <tr>
                        <th class="title-name" style="text-align:center; width: 30%;">NO. MATERIAL</th>
                        <th class="title-name" style="text-align:center; width: 10%;">QTY</th>
                        <th class="title-name" style="text-align:center; width: 60%;">NAMA MATERIAL</th>     
                      </tr>
                    </thead>
                    <tr v-if="!type_part['2']">
                      <td colspan="5" style="text-align:center"> No material are selected </td>
                    </tr>
                    <tr v-else v-for="(item, index)  in type_part['2']"
                      :key="index">
                      <td >{{ item.spare_part_master_code }}</td>
                      <td >{{item.pkb_spare_part_qty}}</td>
                      <td >{{item.spare_part_master_name}}</td>
                    </tr>                    
                  </table>
                </td>
                <td>
                  <table v-if="type_part"  class="table-kotak" style="border-collapse: width:100%; collapse; margin-top:5px; margin-bottom:5px;">
                    <thead>                    
                    <tr>
                      <th class="title-name" style="text-align:center; width: 30%;">NO. SPARE PART</th>
                      <th class="title-name" style="text-align:center; width: 10%;">QTY</th>
                      <th class="title-name" style="text-align:center; width: 60%;">NAMA PART</th>     
                    </tr>
                    </thead>
                    <tr v-if="!type_part['1']">
                      <td colspan="5" style="text-align:center; color:#aaaa; "> No spare part are selected </td>
                    </tr>
                    <tr v-else v-for="(item, index)  in type_part['1']"
                      :key="index">
                      <!-- <td >{{ index+1 }}</td> -->
                      <!-- <td >{{ item.service_category_code }}</td> -->
                      <td >{{ item.spare_part_master_code }}</td>
                      <td >{{item.pkb_spare_part_qty}}</td>
                      <td >{{item.spare_part_master_name}}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            
            <table class="table-inside-td" style="width:100%;  border: 1px solid black; margin-top: 5px; table-layout: fixed;" >
              <colgroup>
                <col style="width: 90mm">
                <col style="width: 90mm">
              </colgroup>
              <tr>
                <td style="border-bottom: 1px solid black; border-right: 1px solid black;">Keluhan</td>
                <td style="border-bottom: 1px solid black; ">Analisa</td>
              </tr>
              <tr>
                <td style="border-right: 1px solid black;">
                  <table  style="border-collapse: width:100%; collapse; ">
                    <colgroup>
                      <col style="width: 2mm">
                      <col style="width: 78mm">
                    </colgroup>
                    <tr  v-for="(item, index)  in pkb.pkb_service_estimate.keluhan"
                      :key="index">
                      <td >{{ index+1 }}.</td>
                      <td >{{ item.keluhan }}</td>
                    </tr>
                  </table>    
                </td>
                      
                    <!-- <tr>
                      <td><b>CATATAN :</b></td>
                      <td><p>{{pkb.pkb_catatan}}</p></td>
                    </tr> -->
          
                <td>
                  <table  style="border-collapse: width:100%; collapse; ">
                          <colgroup>
                            <col style="width: 2mm">
                            <col style="width: 83mm">
                          </colgroup>
                          <tr  v-for="(item, index)  in pkb.pkb_service_estimate.keluhan"
                            :key="index">
                            <!-- <td >{{ index+1 }}</td> -->
                            <!-- <td >{{ item.service_category_code }}</td> -->
                            <td v-if="item.analisa">{{ index+1 }}.</td>
                            <td v-if="item.analisa">{{ item.analisa }}</td>
                          </tr>
                        </table>
                        
                      </td>
                <!-- <td><b>Keluhan :</b><br>
                  <table  style="border-collapse: width:100%; collapse; margin-top:10px; margin-bottom:10px;">
                    <colgroup>
                      <col style="width: 2mm">
                      <col style="width: 78mm">
                    </colgroup>
                    <tr  v-for="(item, index)  in pkb.pkb_service_estimate.keluhan"
                      :key="index">
                      <td >{{ index+1 }}.</td>
                      <td >{{ item.keluhan }}</td>
                    </tr>
                  </table>
                </td> -->
                <!-- <td>
                  <table v-if="type_part" class="table-kotak" style="border-collapse: collapse; ">
                    <thead>
                      <tr>
                        <th class="title-name" style="text-align:center; width: 40%;">NO. MATERIAL</th>
                        <th class="title-name" style="text-align:center; width: 10%;">QTY</th>
                        <th class="title-name" style="text-align:center; width: 50%;">NAMA MATERIAL</th>     
                      </tr>
                    </thead>
                    <tr v-if="!type_part['2']">
                      <td colspan="5" style="text-align:center"> No material are selected </td>
                    </tr>
                    <tr v-else v-for="(item, index)  in type_part['2']"
                      :key="index">
                      <td >{{ item.spare_part_master_code }}</td>
                      <td >{{item.pkb_spare_part_qty}}</td>
                      <td >{{item.spare_part_master_name}}</td>
                    </tr>                    
                  </table>
                </td> -->
              </tr>
            </table>
            
            <table class="table-inside-td" style="width:100%;  border: 1px solid black; margin-top: 5px; table-layout: fixed;" >
              <colgroup>
                <col style="width: 140mm">
                <!-- <col style="width: 70mm"> -->
                <col style="width: 40mm">
              </colgroup>
              <tr>
                <td>
                  <table style="">
                    <colgroup>
                      <col style="width: 70mm">
                      <col style="width: 70mm">
                    </colgroup>
                    <tr>
                      <td><b>PERINTAH KERJA :</b></td>
                      <td><b>CATATAN :</b></td>
                    </tr>
                    <tr>
                      <td>
                        <p>{{pkb.pkb_perintah_kerja}}</p>
                      </td>
                      <td><p>{{pkb.pkb_catatan}}</p></td>
                    </tr>
                  </table>
                </td>
                <td>
                  <table class="table-kotak" style="border-collapse: collapse; margin-top:10px; margin-bottom:10px;">
                    <thead>
                      <tr>
                        <th class="title-name" style="text-align:center; width: 40%;">TEKNISI</th>     
                      </tr>
                    </thead>
                    <tr style="border-right:1px solid black; border-left:1px solid black;">&zwnj;</tr>
                    <tr style="border-right:1px solid black; border-left:1px solid black;">&zwnj;</tr>
                    <tr style="border-right:1px solid black; border-left:1px solid black;">&zwnj;</tr>
                    <tr >
                      <td style="text-align:center; font-weight: bold;">{{pkb.pkb_teknisi_name.name}}</td>
                    </tr>
                  </table>
                </td>
                
              </tr>
              
                </table>

                  
          </md-content>
          <md-content>
            <table style="width:100%;  border: 1px solid black; margin-top: 5px; table-layout: fixed;" >
              <colgroup>
                <col style="width: 30mm">
                <col style="width: 60mm">
                <col style="width: 30mm">
                <col style="width: 60mm">
              </colgroup>
              <tr>
                <td style="border-right: 1px solid black; text-align:center;"><b>Renc. Pembayaran:</b></td>
                <td style="border-right: 1px solid black">{{pkb.pkb_payment_plan}}</td>
                <td style="border-right: 1px solid black; text-align:center;"><b>Work Order Type:</b></td>
                <td>{{pkb.pkb_work_order_type}}</td>
              </tr>
            </table>

            <table class="table-inside-td" style="width:100%; border: 1px solid black; table-layout: fixed; margin-top: 5px;" >
              <colgroup>
                <!-- <col style="width: 19mm">
                <col style="width: 63mm"> -->
                <col style="width: 82mm">
                <col style="width: 35mm">
                <col style="width: 65mm">
              </colgroup>
              <tr>
                <!-- <td class="bold-title" style="text-decoration: underline;">Ketentuan:</td> -->
                <td >
                  <ul style="font-size:10.5px; margin-left:13px; margin-top:10px;">
                    <li>Kendaraan akan dikerjakan setelah penerimaan tanda jadi / uang muka</li>
                    <li>Apabila terdapat penambahan diluar estimasi ini akan diberitahukan terlebih dahulu</li>
                    <li> Perusahaan tidak bertanggung jawab atas segala kerusakan yang disebabkan hal hal di luar kekuasaan perusahaan, misalnya : huru hara , gempa bumi , dsb</li>
                  </ul>
                </td>
                <td>
                  <table>
                    <tr>
                      <td style="text-align:center; font-weight:bold;">SERVICE ADVISOR</td>
                    </tr>
                    <tr>&zwnj;</tr>
                    <tr>&zwnj;</tr>
                    <!-- <tr>&zwnj;</tr> -->
                    <tr>
                      <td style="text-align: center;"><sub>(</sub><span style="display:inline-block; border-bottom:1px solid black;  padding-top:0mm">{{pkb.pkb_service_estimate.sa_name.name}}</span><sub>)</sub></td>
                    </tr>
                  </table>
                </td>
                <td>
                  <table>
                    <tr>
                      <td style="text-align:center; font-weight:bold;">CUSTOMER</td>
                    </tr>
                    <tr>&zwnj;</tr>
                    <tr>&zwnj;</tr>
                    <!-- <tr>&zwnj;</tr> -->
                    <tr>
                      <td style="text-align: center;"><sub>(</sub><span style="display:inline-block; border-bottom:1px solid black;  padding-top:0mm">`{{pkb.pkb_service_estimate.client.client_name}}</span><sub>)</sub></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>

            <table class="table-inside-td" style="width:100%;  border: 1px solid black; margin-top: 0px; table-layout: fixed;" >
                <colgroup>
                  <col style="width: 22mm">
                  <col style="width: 21mm">
                  <col style="width: 21mm">
                  <col style="width: 21mm">
                  <col style="width: 21mm">
                  <col style="width: 21mm">
                  <col style="width: 25mm">
                  <col style="width: 18mm">
                </colgroup>
                <tr>
                  <td style="font-weight:bold">Jam Aktual:</td>
                  <td></td>
                  <td style="font-weight:bold">KM.Terakhir:</td>
                  <td></td>
                  <td style="font-weight:bold"><b>PKB Terakhir:</b></td>
                  <td ></td>
                  <td style="font-weight:bold;"><b>Tgl.PKB Terakhir:</b></td>
                  <td ></td>
                </tr>
            </table>
            </md-content>
          
            <!-- <button class="noprint" @click="printInvoice" >Print Invoice</button>
            <button class="noprint" @click="generateReport" >Print Invoice</button> -->
        
    </div>
      </div>
            

    <div v-bind:style="{ display: not_found}">
      <center  v-if="pkb == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Go to List PKB?</a>
        </p>
      </center>
    </div>
  </div>
</template>

<script>
  import formMixin from "@/mixins/form-mixin";
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import Swal from 'sweetalert2';
  import Vue from "vue";
  export default {
     name: "detail-service-estimates",

    // props: {
    //   pkb: Object,
    // },

    components: {
      
      
    }, 

    props: {
    data_id: null,
    },

    mixins: [formMixin],

    data: () => ({
      not_found: 'none',
      role:"",
      pkb: null,
      total_pekerjaan: 0,
      total_part: 0,
      subject: 0,
      ppn: 0,
      total_estimate: 0,
      type_part: null,
    }),

    created() {
      this.getPKBData();
    },

    methods: {
      //fungsi yang berjalan ketika page pertamakali dibuka
      async getPKBData(){
        //ambil role permission list current user
        this.role =  await this.$store.getters["role_permission/route_filter"]
        //ambil data pkb dari server berdasarkan id yang dikirim di route
          await this.$store.dispatch("workshop_pkb/get", this.data_id.id)
          this.pkb = await this.$store.getters["workshop_pkb/pkb"]
          
          if(this.pkb.pkb_spion == 1){
         this.pkb.pkb_spion = true
        }
        if(this.pkb.pkb_battery_1 == 1){
         this.pkb.pkb_battery_1 = true
        }
        if(this.pkb.pkb_battery_2 == 1){
         this.pkb.pkb_battery_2 = true
        }
        if(this.pkb.pkb_rak_depan == 1){
         this.pkb.pkb_rak_depan = true
        }
        if(this.pkb.pkb_rak_belakang == 1){
         this.pkb.pkb_rak_belakang = true
        }

           //check apakah data dari api ada
        if(!this.pkb){
          //jika tidak ada munculkan bagian not found yang defaultnya di hide
          this.not_found = "block"
          return
        }
         // console.log(await this.$store.getters["workshop_pkb/pkb"])
          
          //group data part di pisah berdasarkan dengan jenisnya
           var grouped  = Object.create(null);
          this.pkb.pkb_part.forEach(function (a) {
            grouped[a.spare_part_master_type] = grouped[a.spare_part_master_type] || [];
            grouped[a.spare_part_master_type].push(a);
          });
        //set var type part berdasarkan array group yang telah dibuat sebelumnya
        this.type_part = grouped
        //console.log(this.type_part[1]);
         
      //     await this.$store.dispatch("workshop_pkb/partTable")
      //  if(await this.$store.getters["workshop_pkb/pkb"] && await Object.keys(this.$store.getters["workshop_pkb/pkb"]).length!=0){
      //     this.tableRepairStatus = await this.$store.getters["workshop_pkb/pkb"]
      
      // }

            this.pkb.vehicle_plat_no = null
            this.pkb.vehicle_engine_no = null
            this.pkb.vehicle_fuel_type = null
            this.pkb.vehicle_vehicle_model = null
            this.pkb.vehicle_chassis_no = null
            this.pkb.vehicle_production_year = null
            this.pkb.vehicle_colour = null
          if(this.pkb.pkb_service_estimate.vehicle_types){
            this.pkb.vehicle_vehicle_model =  this.pkb.pkb_service_estimate.vehicle_types.vehicle_types.vehicle_brands.vehicle_brand_name+', '+ this.pkb.pkb_service_estimate.vehicle_types.vehicle_types.vehicle_model+' '+ this.pkb.pkb_service_estimate.vehicle_types.vehicle_types.vehicle_year_model
            this.pkb.vehicle_plat_no = this.pkb.pkb_service_estimate.vehicle_types.vehicle_plate_no
            this.pkb.vehicle_engine_no = this.pkb.pkb_service_estimate.vehicle_types.vehicle_engine_no
            this.pkb.vehicle_chassis_no = this.pkb.pkb_service_estimate.vehicle_types.vehicle_chassis_no
            if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_types.vehicle_fuel_type == 1){
              this.pkb.vehicle_fuel_type = "Bensin"
            }
            else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_types.vehicle_fuel_type == 2){
              this.pkb.vehicle_fuel_type = "Diesel"
            }
            else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_types.vehicle_fuel_type == 3){
              this.pkb.vehicle_fuel_type = "Listrik"
            }
            else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_types.vehicle_fuel_type == 4){
              this.pkb.vehicle_fuel_type = "Hybrid"
            }
            else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_types.vehicle_fuel_type == 5){
              this.pkb.vehicle_fuel_type = "CNG"
            }
            
            this.pkb.vehicle_production_year = this.pkb.pkb_service_estimate.vehicle_types.vehicle_production_year
            if(this.pkb.pkb_service_estimate.service_estimate_type == 1){
              if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_body_color == 0){
                  this.pkb.vehicle_colour = "Putih"
                }
                else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_body_color == 1){
                  this.pkb.vehicle_colour = "Putih Kuning"
                }
                else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_body_color == 2){
                  this.pkb.vehicle_colour = "Putih Metalik"
                }
                else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_body_color == 3){
                  this.pkb.vehicle_colour = "Hitam"
                }
                else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_body_color == 4){
                  this.pkb.vehicle_colour = "Hitam Metalik"
                }
                else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_body_color == 5){
                  this.pkb.vehicle_colour = "Silver"
                }
                else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_body_color == 6){
                  this.pkb.vehicle_colour = "Silver Metalik"
                }
                else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_body_color == 7){
                  this.pkb.vehicle_colour = "Abu Abu"
                }
                else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_body_color == 8){
                  this.pkb.vehicle_colour = "Abu Abu Metalik"
                }
                else if(this.pkb.pkb_service_estimate.vehicle_types.vehicle_body_color == 9){
                  this.pkb.vehicle_colour = "Hijau"
                }
            }
            else if(this.pkb.pkb_service_estimate.service_estimate_type == 2){
              this.pkb.vehicle_colour = this.pkb.pkb_service_estimate.vehicle_types.vehicle_body_color
            }
    
            
         
         }
         
        
      },
      //fungsi update komfirmasi
      updateStatusConfirmation(type) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, '+type+'!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateStatus(type)
          }
        });
    },
    
    //pindah ke page add faktur dengan query pkb id yang dikirm lewat route
    createFaktur(id) {
      this.$router.push({ name: 'Add Faktur',  query: { pkb_id: id} })
      
    },


    //pindah ke page add nota part dengan query pkb id yang dikirm lewat route
     createNotaPart(id) {
      this.$router.push({ name: 'Add Nota Part',  query: { pkb_id: id } })
      
    },

    
    //pindah ke page add nota jasa dengan query pkb id dan pkb no yang dikirm lewat route
     createNotaJasa(id,no) {
      this.$router.push({ name: 'Add Nota Jasa Bkl',  query: { pkb_id: id,pkb_no: no } })
      
    },

    
    //pindah ke page detail nota part dengan params pkb id yang dikirm lewat route
    showNotaPart(id) {
      this.$router.push({name: 'Detail Nota Part', params: { pkb: id, id }})
    },

    //pindah ke page detail nota jasa dengan params pkb id yang dikirm lewat route
    showNotaJasa(id) {
      this.$router.push({name: 'Detail Nota Jasa Bkl', params: { pkb: id, id }})
    },

    //pindah ke page detail faktur dengan params pkb id yang dikirm lewat route
    showFaktur(id) {
      this.$router.push({name: 'Detail Faktur', params: { pkb: id, id }})
    },

    //pindah ke page edit pkb dengan params pkb id yang dikirm lewat route
    editPkb(id) {
      this.$router.push({ name: 'Edit PKB', params: { pkb:id, id } })
    },

// kembali ke list pkb
    backToList() {
      this.$router.replace({ name: 'List PKB'})
    },

    closeDetail(){
      if(this.data_id.mode && this.data_id.mode == "se"){
          this.$parent.$parent.modalCloseShowDetailPkb();
        }
        else{
          this.$parent.$parent.modalCloseDetail();

        }
    },


//fungsi konfirmasi delete
    deleteConfirmation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.deletePkb(id)
          }
        });
    },
    //fungsi delete
    async deletePkb(id) {
       try {
         //kirim data keserver
          await this.$store.dispatch("workshop_pkb/destroy", id)
          //panggil alert succes
          await this.$store.dispatch("alerts/success", "User data delete successfully.")
          //jalankan fungsi kembali kelist
           this.backtoList()
          //await this.getList();
        } catch (e) {
          //panggil alert error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }
    },

      //fungsi update status
      async updateStatus(type) {

        const data = {
          type: "workshop_pkbs",
          id:this.pkb.id,
          current_status:this.pkb.pkb_status,
          request:type
        }

        //console.log(data)
        try {
          //kirim data keserver
        await this.$store.dispatch("workshop_pkb/update_status", data);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "Status Successfully update."
        );
        //jalankan fungsi kembali kelist
           this.getPKBData()
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong"
        );
      }

      },
      //fungsi untuk memunculkan mode print preview
      printPage(){
         window.print()
      }
      
    }
  };
</script>
<style scoped>
.page-break {
    page-break-inside:avoid;
    page-break-after:always;
}

.title-name{
  background-color:powderblue;
}
table{
  width:100%;
  table-layout: fixed;
  font-size: 0.9em;
}
.table-kotak{
  border-collapse: collapse;
}
table.table-kotak td{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
table.table-kotak th{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print{
  visibility: hidden;
}
.checkboxes label {
  display: inline-block;
  padding-right: 10px;
  white-space: nowrap;
}
.checkboxes input {
  vertical-align: middle;
}
.checkboxes label span {
  vertical-align: middle;
}
.checkboxes td {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.checkboxes {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.info {
  line-height: 17px;
}
.info td {
margin: 4px;
}
.bold-title{
font-weight:bold;
}
.table-inside-td td {
  vertical-align: top;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
}

@media print{

  

   .print{
       visibility: visible;
       zoom: 80%;
      margin: none;
   }
   .noprint{
     display: none;
   }

  
}

/* .md-layout{
  background-color: white;
} */

.md-card{
  box-shadow: 0 3px 5px 1px rgb(0 0 0/ 14%);
}

.color{
  background-color: #1976d2 !important;
}
</style>